module.exports = __webpack_public_path__ + "static/media/corporate-services-img7.4589955c.jpg";